import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";

const FEATURES = [
  { title: "His Identity", body: "The eternal Son of God, one Person in two natures — fully God, fully man." },
  { title: "His Birth", body: "Conceived by the Holy Spirit, born of the virgin Mary in Bethlehem." },
  { title: "His Life and Teaching", body: "A public ministry of authoritative teaching, healing, and compassion." },
  { title: "His Miracles", body: "Signs pointing to who He is — Lord over sickness, storms, sin, and death." },
  { title: "His Compassion", body: "For the outcast, the sinner, the doubting — He is patient and kind." },
  { title: "His Death", body: "A substitutionary death for our sins — the just for the unjust." },
  { title: "His Resurrection", body: "Bodily raised on the third day, witnessed by hundreds." },
  { title: "His Ascension", body: "Returned to the Father, seated at His right hand, praying for His people." },
  { title: "His Return", body: "He will return in glory to make all things new and to judge in righteousness." },
];

export default function KnowJesus() {
  return (
    <>
      <PageHero
        eyebrow="Know Jesus"
        title="Who is Jesus Christ?"
        subtitle="Every religion has an opinion about Jesus. Christianity worships Him. See who the Bible actually presents Him to be."
        dark
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {FEATURES.map((f, i) => (
              <div key={i} className="paper-card p-8">
                <span className="eyebrow text-forest">0{i + 1}</span>
                <h3 className="font-serif text-2xl mt-3 text-ink" style={{ fontWeight: 500 }}>{f.title}</h3>
                <p className="body-copy mt-3 text-ink-muted">{f.body}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 border border-border p-10 bg-subtle">
            <span className="eyebrow">Why Jesus is the only mediator</span>
            <h3 className="heading-3 mt-3">
              "For there is one God and one mediator between God and mankind, the man Christ Jesus." — 1 Timothy 2:5
            </h3>
            <p className="body-copy mt-5 text-ink-muted">
              Because Jesus is both fully God and fully human, He alone stands in the place of reconciliation. No
              other name has been given by which we must be saved (Acts 4:12). This is not arrogance about Jesus. It
              is the Bible's clear witness about Him.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/articles/who-is-jesus-christ" className="btn-primary">Read the article</Link>
              <Link to="/articles/did-jesus-rise-from-the-dead" className="btn-ghost">Did Jesus really rise?</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
